import {useState, useLayoutEffect} from 'react'
import {isMobile} from './utils/deviceUtils'

export default function useWindowManager() {

    const [size, setSize] = useState({
        height: window.innerHeight,
        width: window.innerWidth, 
    })

    const [portrait, setPortrait] = useState(false)

    const [windowResizing, setWindowResizing] = useState(false)
    const [windowResized, setWindowResized] = useState(false)

    function getWindowResized(){
        let cur = windowResized
        setWindowResized((windowResized) => false)
        return cur
    }

    /*

            WINDOW RESIZE

    */
    useLayoutEffect(() => {
        let resizeTimeout
        const handleResize = () => {

            clearTimeout(resizeTimeout)
            setWindowResizing(true)


            resizeTimeout = setTimeout(() => {
                setWindowResizing(false)
                setWindowResized(true)
                }, 500)

            setSize({
                height: window.innerHeight,
                width: window.innerWidth, 
            })

            setPortrait(prevPortrait => window.innerHeight > window.innerWidth || isMobile() ? true : false);
           
        }

        window.addEventListener('resize', handleResize)
        handleResize()
        return () => window.removeEventListener('resize', handleResize)
    }, [])


    return {
        size,
        windowResizing,
        portrait,
        getWindowResized
    }

}

